import { render, staticRenderFns } from "./SupportLoginCode.component.vue?vue&type=template&id=3d39e4fa&scoped=true"
import script from "./SupportLoginCode.component.vue?vue&type=script&lang=ts"
export * from "./SupportLoginCode.component.vue?vue&type=script&lang=ts"
import style0 from "./SupportLoginCode.component.vue?vue&type=style&index=0&id=3d39e4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d39e4fa",
  null
  
)

export default component.exports